"use client"

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useUSDCoinQuote } from "@/hooks/coins/useUSDCoinQuote"

type Props = {
  poolAddress: string
  ethPrice: number
}

export function PopularityIndicator({ poolAddress, ethPrice }: Props) {
  const quote = useUSDCoinQuote(poolAddress, ethPrice)?.amountOut
  const priceInUSD = quote ? 1 / Number(quote / BigInt(1e18)) : 0
  const popularity = calculatePopularity(priceInUSD)

  return (
    <Tooltip delayDuration={250}>
      <TooltipTrigger>
        <div className="flex items-center gap-1">
          <span className="text-sm text-wood-500 mr-1">Popularity</span>
          {new Array(5).fill(0).map((n, i) => (
            <div
              key={i}
              className={`rounded-full size-3 ${popularity > i ? "bg-green-600" : "bg-input"}`}
            />
          ))}
        </div>
      </TooltipTrigger>

      <TooltipContent className="max-w-[280px]">
        Popularity shows how much this post has resonated with readers and how
        much support it has received compared to other posts on Paragraph.
      </TooltipContent>
    </Tooltip>
  )
}

const calculatePopularity = (price: number): number => {
  if (price > 0.00001) return 5
  if (price > 0.000005) return 4
  return 3
}
